import flagus from "../assets/images/flags/us.svg";
import flagIndia from "../assets/images/flags/in.svg";

const languages = {
  en: {
    label: "English",
    flag: flagus,
  },
  hi: {
    label: "हिन्दी",
    flag: flagIndia,
  },
}

export default languages
